<div class="w-full grid grid-cols-2 gap-2">
    <button class="px-4 text-font border rounded h-12 google" (click)="handleGoogleLogin()">
        <div class="flex flex-row justify-center items-center"><ng-icon name="faBrandGoogle" class="mr-2" />Google</div>
    </button>
    <button class="px-4 text-white border rounded h-12 microsoft" (click)="handleMicrosoftLogin()">
        <div class="flex flex-row justify-center items-center"><ng-icon name="faBrandMicrosoft" class="mr-2" />Microsoft
        </div>
    </button>
    <button class="px-4 text-white border rounded h-12 discord">
        <div class="flex flex-row justify-center items-center" (click)="handleDiscordLogin()"><ng-icon
                name="faBrandDiscord" class="mr-2" />Discord
        </div>
    </button>
    <!-- <button class="px-4 text-white border rounded h-12 instagram">
        <div class="flex flex-row justify-center items-center"><ng-icon name="faBrandInstagram" class="mr-2" />Instagram
        </div>
    </button>
    <button class="px-4 text-white border rounded h-12 apple">
        <div class="flex flex-row justify-center items-center"><ng-icon name="faBrandApple" class="mr-2" />Apple</div>
    </button>
    <button class="px-4 text-white border rounded h-12 facebook">
        <div class="flex flex-row justify-center items-center"><ng-icon name="faBrandFacebookF" class="mr-2" />Facebook
        </div>
    </button> -->
</div>